import { render, staticRenderFns } from "./codeEdit.vue?vue&type=template&id=d546f634&scoped=true&"
import script from "./codeEdit.vue?vue&type=script&lang=js&"
export * from "./codeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d546f634",
  null
  
)

export default component.exports